import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Box from '@mui/material/Box';
//components
import TabsPages from './../tabs/TabsPages';
import { estableceMenuActivo } from '../../redux/slices/menuSlice';

const Body = () => {
  const { menusAbiertos, menuActivo, menusAbiertosComponents } = useSelector(
    (state) => state.menuReducer,
  );

  const dispatch = useDispatch();

  const handleMenuActivo = (pagina) => {
    dispatch(estableceMenuActivo(pagina));
  };

  return (
    <Box
      sx={{
        p: 0,
        m: 0,
        width: '100%',
        height: 'calc(100vh - 48px)',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        bgcolor: 'background.default',
      }}
    >
      <Box sx={{ width: '100%', flexShrink: 0 }}>
        <TabsPages
          items={menusAbiertos}
          onMenuActivo={handleMenuActivo}
          menuActivo={menuActivo}
        />
      </Box>
      <Box
        sx={{
          width: '100%',
          flexGrow: 1,
          height: 'calc(100vh - 96px)',
          overflow: 'hidden',
          bgcolor: 'background.default',
          textAlign: 'center',
        }}
      >
        {menusAbiertosComponents?.map((comp, index) => (
          <div
            key={menusAbiertos[index]?.idMenu ?? index}
            style={{
              height: '100%',
              minHeight: '100%',
              minWidth: '100%',
              display:
                menuActivo.idMenu === menusAbiertos[index]?.idMenu
                  ? 'block'
                  : 'none',
            }}
          >
            {comp}
          </div>
        ))}
      </Box>
    </Box>
  );
};

export default Body;
